import { render, staticRenderFns } from "./Proxy.vue?vue&type=template&id=278404b0"
import script from "./Proxy.vue?vue&type=script&lang=js"
export * from "./Proxy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports